<template>
  <div class="user_body">
    <span class="title">配送方式</span>
    <div class="delivery_method_list">
      <span class="title3" 
      :class="delivery_method == item.value?'active':''" 
      v-for="(item,index) in delivery_method_list" 
      :key="index" 
      @click="changeDeliveryMethod(item)">{{item.name}}</span>
    </div>
    <div class="add_list" v-if="delivery_method == 1">
      <div
        :class="item.is_default==1?'add_item2':'add_item3'"
        v-for="(item,index) in showAddressList"
        :key="index"
        @click="setDefaultAddress(index,item)"
      >
        <span class="title2">{{item.consignee}}</span>
        <span class="text1">{{item.phone}}</span>
        <span class="text1">{{item.province_name }}{{ item.city_name }}{{ item.area_name }}{{ item.address }}</span>

        <div class="add_opt">
          <span @click.stop="editAddress(item)">修改</span>
          <span @click.stop="confirmDeleteAddress(item.id)">删除</span>
        </div>
      </div>
    </div>

    
    <div class="more_add" v-if="addressList.length > 4" @click="changeShowAddressList">显示更多地址</div>
    <div class="more_add" @click="toAddAddress">添加地址</div>
    <span class="title">产品</span>
    <div class="product_lsit">
      <div class="product_info header">
       
        <span style="flex:2">名称</span>
        <span style="flex:1">规格</span>
        <span style="flex:1">单价</span>
        <span style="flex:1">数量</span>
        <span style="flex:1">小计</span>
      </div>
      <div class="product_info" v-for="(item,index) in goods" :key="index">
       
        <span style="flex:2">{{item.title || ''}}</span>
        <span style="flex:1">{{item.sku.sku_name||'--'}}</span>
        <span style="flex:1">{{item.sku.price||item.price}}元</span>
        <span style="flex:1">X&nbsp;{{item.total}}</span>
        <span style="flex:1">{{((item.sku.price||item.price)*item.total).toFixed(2)}}元</span>
      </div>
    </div>
    <div class="line"></div>
    <!-- 选择优惠券 -->
    <div class="coupon">
      <div class="label">选择优惠券</div>
      <div class="coupon_list">
        <el-select size="medium" v-model="coupon_id" placeholder="请选择优惠券" @change="changeCoupon" clearable class="coupon_select">
          <el-option v-for="item in couponList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
    </div>
    <div class="prices">
      <div class="p_left">
        <div class="p_left_l">
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            placeholder="给商家留言，选填"
            v-model="remarks"
          ></el-input>
        </div>
        <div class="p_left_r">
          <div class="prices_1">
            <span>产品件数：</span>
            <span>{{countGoods}}</span>
          </div>
          <div class="prices_1">
            <span>产品总价：</span>
            <span>{{original_price}}元</span>
          </div>
          <div class="prices_1">
            <span>优惠金额：</span>
            <span class="active_price">{{discount_price}}元</span>
          </div>
          <div class="prices_1">
            <span>运费：</span>
            <span >{{express_fee}}元</span>
          </div>
        </div>
      </div>

      <div class="prices_2">
        <span>应付金额：</span>
        <span class="active_price">{{total_price}}元</span>
      </div>
    </div>
    <div class="line"></div>
    <div class="order_btns">
      <span class="order_btns2" @click="$router.push('/shopcart')">返回购物车</span>
      <span class="order_btns1" @click="submitOrder">去结算</span>
    </div>
    <el-dialog :title="isEdit ? '编辑收货地址' : '添加收货地址'" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <el-form :model="addressForm" :rules="rules" ref="addressForm" label-width="0px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="consignee">
              <el-input v-model="addressForm.consignee" autocomplete="off" placeholder="姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="phone">
              <el-input v-model="addressForm.phone" autocomplete="off" placeholder="手机号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top:10px;">
          <el-col :span="24">
            <el-form-item prop="region">
              <el-cascader
                v-model="addressForm.region"
                :options="regionOptions"
                @change="handleRegionChange"
                placeholder="选择省 / 市 / 区 / 街道"
                style="width: 100%"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top:10px;">
          <el-col :span="24">
            <el-form-item prop="address">
              <el-input v-model="addressForm.address" autocomplete="off" placeholder="详细地址" type="textarea" :rows="3"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top:10px;">
          <el-col :span="24">
            <el-checkbox v-model="addressForm.is_default" :true-label="1" :false-label="0">设为默认地址</el-checkbox>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <span @click="submitAddress" class="btn1">确定</span>
        <span @click="dialogVisible = false" class="btn2">取消</span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentIndex: 0,
      list: [{}, {}, {}, {}],
      dialogVisible: false,
      remarks: '',//留言
      order_id: '',//订单id
      address_id:'',//选择的地址
      // 确认订单的参数
      goods_id:'',//商品id
      total:'',//商品数量
      cart_id:'',//购物车id
      coupon_id:'',//优惠券id
      sku_id:'',//sku_id
      delivery_method:0,//配送方式
      store_id:'',//店铺id
      // *************
      goods: [],
      total_fee: 0,
      totalNum: 0,
      total_price: 0,
      original_price: 0,
      express_fee: 0,
      discount_price: 0,
      hexiao_realname:'',
      hexiao_mobile:'', 
      // 地址相关
      delivery_method_list:[],
      addressList: [],
      showAddressList:[],
      couponList:[],
      dialogVisible: false,
      isEdit: false,
      addressForm: {
        id: '',
        consignee: '',
        phone: '',
        region: [],
        address: '',
        is_default: 0
      },
      rules: {
        consignee: [
          { required: true, message: '请输入收货人姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        region: [
          { required: true, message: '请选择所在地区', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ]
      },
      regionOptions: [],
      isSubmit: false,
    };
  },
  watch: {
    '$route.query': {
      handler(newVal) {
        console.log('newVal is',newVal)
        if(newVal.goods_id) this.goods_id = newVal.goods_id;
        if(newVal.cart_id) this.cart_id = newVal.cart_id;
        if(newVal.address_id) this.address_id = newVal.address_id;
        if(newVal.goods_id) this.goods_id = newVal.goods_id;
        if(newVal.total) this.total = newVal.total;
        if(newVal.coupon_id) this.coupon_id = newVal.coupon_id;
        if(newVal.sku_id) this.sku_id = newVal.sku_id;
        this.orderComfirm();
      },
      immediate: true
    }
  },
  computed: {
    countGoods(){
      return this.goods.reduce((total, item) => total + item.total, 0);
    }
  },
  created(){
    this.getAddressList();
    this.getRegions();
  },
  mounted() {},
  methods: {
    changeCoupon(value){
      this.orderComfirm();
    },
    getCouponList(){
      let data = {
					price:this.original_price,
					cart_id:this.cart_id,
					goods_id:this.goods_id,
					type:1
				}
      this.$api.getUserCouponList(data).then(res => {
        if(res.code == 1){
          this.couponList = res.data;
        }
      }).catch(err => {
        console.log(err);
      });
    },
    toAddAddress(){
      this.dialogVisible = true;
      this.isEdit = false;
      this.resetForm();
    },
    orderComfirm(){
      let data = {
        goods_id: this.goods_id,
        cart_id: this.cart_id,
        delivery_method: this.delivery_method,
        coupon_id: this.coupon_id,
        total: this.total,
        sku_id: this.sku_id,
        store_id: this.store_id,
      }
      console.log('data is',data)
      this.$api.confirmOrder(data).then(res => {
					if(res.code == 1){
						this.goods = res.data.goods;
						this.total_fee = res.data.total_fee;
						this.totalNum = res.data.totalNum;
						this.total_price = res.data.total_price;
						this.original_price = res.data.original_price;
						this.express_fee = res.data.express_fee;
						this.discount_price = res.data.discount_price;
						this.delivery_method = res.data.delivery_method;
						this.delivery_method_list = res.data.delivery_method_list;
            if(this.couponList.length<=0){
              this.getCouponList()
            }
					}
					else{
						this.$message.error(res.message);
					}
				}).catch(err => {
					console.log(err);
				});
    },
    submitOrder(){
      if(this.isSubmit) return;
      this.isSubmit = true;
      var data = {
					goods_id:this.goods_id,
					cart_id:this.cart_id,
					address_id:this.address_id,
					coupon_id:this.coupon_id,
					total:this.total,
					remarks:this.remarks,
					sku_id:this.sku_id,
					store_id:this.store_id,
					delivery_method:this.delivery_method,
					hexiao_realname:this.hexiao_realname,
					hexiao_mobile:this.hexiao_mobile,
				}
				this.$api.submitOrder(data).then(res => {
					this.is_submit = false;
					if(res.code == 1){
						// this.$util.jump("/pages/public/pay?order_type=1&order_no="+res.data.order_no,2);
            this.$router.push({
              path: '/pay',
              query: {
                order_type: 1,
                order_no: res.data.order_no
              }
            });
					}
					else{
						this.$message.error(res.message);
					}
				}).catch(err => {
					this.is_submit = false;
				});
    },
    changeShowAddressList(){
      if(this.showAddressList.length <= 4){
        this.showAddressList = [...this.addressList];
      }else{
        this.showAddressList = this.addressList.slice(0,4);
      }
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    goNav(index) {
      this.currentIndex = index;
    },
    // ***********************地址相关**************************
    changeDeliveryMethod(item){
      this.delivery_method = item.value;
    },
     // 获取地址列表
     async getAddressList() {
      try {
        const res = await this.$api.getAddressList();
        if (res.code === 1) {
          this.addressList = res.data;
          this.showAddressList = this.addressList.slice(0,4);
          this.address_id = this.addressList.find(item => item.is_default == 1).id;
          console.log('this.addressList is',this.addressList)
         
        } else {
          this.addressList = [];
          this.showAddressList = [];
          // this.$message.error(res.message || '获取地址列表失败');
        }
      } catch (err) {
        this.$message.error(err.message || '获取地址列表失败');
      }
    },
    
    // 获取地区数据
    async getRegions() {
      try {
        const res = await this.$api.getRegions();
        if (res.code === 1) {
          this.regionOptions = this.formatRegionOptions(res.data);
        } else {
          this.$message.error(res.message || '获取地区数据失败');
        }
      } catch (err) {
        this.$message.error(err.message || '获取地区数据失败');
      }
    },
    
    // 格式化地区数据为级联选择器格式
    formatRegionOptions(regions) {
      const formatData = (data, level = 0) => {
        return data.map((item,index) => {
          const result = {
            value: item.name,
            label: item.name
          };
          
          if (item.children && item.children.length) {
            result.children = formatData(item.children, level + 1);
          }
          
          return result;
        });
      };
      
      return formatData(regions);
    },
    
    // 处理地区变化
    handleRegionChange(value) {
      console.log('value is',value)
      console.log('this.form.region is',this.addressForm.region)
      // this.addressForm.region = value
    },
    
    // 打开添加地址对话框
    openAddressDialog() {
      this.isEdit = false;
      this.resetForm();
      this.dialogVisible = true;
    },
    
    // 编辑地址
    async editAddress(address) {
      this.isEdit = true;
      this.addressForm = {
        ...address,
        region:[address.province_name,address.city_name,address.area_name,address.street_name]
      };
      
      // 通过地区名称查找对应的地区ID
      const regionNames = address.region;
      // 实际项目中可能需要根据ID获取地区，这里简化处理
      
      this.dialogVisible = true;
    },
    
    // 确认删除地址
    confirmDeleteAddress(id) {
      this.$confirm('确定要删除该地址吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteAddress(id);
      }).catch(() => {
        // 取消删除操作
      });
    },
    
    // 删除地址
    async deleteAddress(id) {
      try {
        const res = await this.$api.delAddress({ id });
        if (res.code === 1) {
          this.$message.success('删除地址成功');
          // 刷新地址列表
          this.getAddressList();
        } else {
          this.$message.error(res.message || '删除地址失败');
        }
      } catch (err) {
        this.$message.error(err.message || '删除地址失败');
      }
    },
    
    // 提交地址表单
    submitAddress() {
      this.$refs.addressForm.validate(async (valid) => {
        if (!valid) {
          return false;
        }
        
        try {
          const res = await this.$api.editAddress(this.addressForm);
          if (res.code === 1) {
            this.$message.success(this.isEdit ? '编辑地址成功' : '添加地址成功');
            this.dialogVisible = false;
            // 刷新地址列表
            this.getAddressList();
          } else {
            this.$message.error(res.message || (this.isEdit ? '编辑地址失败' : '添加地址失败'));
          }
        } catch (err) {
          this.$message.error(err.message || (this.isEdit ? '编辑地址失败' : '添加地址失败'));
        }
      });
    },
    
    // 重置表单
    resetForm() {
      this.addressForm = {
        id: '',
        consignee: '',
        phone: '',
        region: [],
        address: '',
        is_default: 0
      };

      
      if (this.$refs.addressForm) {
        this.$refs.addressForm.resetFields();
      }
    },
    
    // 关闭对话框
    handleClose(done) {
      this.$confirm("确认关闭？未保存的内容将会丢失")
        .then(_ => {
          this.resetForm();
          done();
        })
        .catch(_ => {});
    },
    
    // 选择地址
    async setDefaultAddress(index,item){
      this.addressForm = {...item};
      this.addressForm.is_default = 1;
      this.addressForm.region = [item.province_name,item.city_name,item.area_name,item.street_name];
      try {
          const res = await this.$api.editAddress(this.addressForm);
          if (res.code === 1) {
            this.$message.success('设置默认地址成功');
  
            // 刷新地址列表
            this.getAddressList();
          } else {
            this.$message.error(res.message || '设置默认地址失败');
          }
        } catch (err) {
          this.$message.error(err.message || '设置默认地址失败');
        }
    }
  }
};
</script>
<style lang="less" scoped>
.user_body {
  background: #ffffff;
  padding: 25px;
  margin-top: 110px;
  margin-left: 15%;
  margin-right: 15%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.title {
  color: #666666;
  font-size: 16px;
  margin-top: 16px;
}
.delivery_method_list{
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  .title3 {
  cursor: pointer;
  color: #272727;
  font-size: 14px;
  width: 60px;
  text-align: center;
  padding: 3px 10px;
  border: 1px solid #272727;
  margin-top: 20px;
}
.active{
border: 1px solid #3c9c8f;
  color: #3c9c8f;
}
}

.add_list {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-top: 20px;
  gap: 10px;
}
.add_item {
  width: 280px;
  height: 180px;
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.add_item2 {
  width: calc(25% - 10px);
  height: 180px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border: 1px solid #3c9c8f;
  padding: 20px 10px 0px 20px;
  box-sizing: border-box;
}
.add_item3 {
  width: calc(25% - 10px);
  height: 180px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-size: cover;
  padding: 20px 10px 0px 20px;
  box-sizing: border-box;
  border: 1px solid #e0e0e0;
}
.add_item_img {
  width: 30px;
  height: 30px;
  margin-bottom: 10px;
}
.add_text {
  color: #e0e0e0;
  font-size: 14px;
  font-weight: 800;
}
.title2 {
  color: #333333;
  font-size: 16px;
  margin-bottom: 15px;
}
.text1 {
  color: #333333;
  font-size: 14px;
  margin-bottom: 5px;
  color: #999999;
}

.text3 {
  color: #333333;
  font-size: 14px;
  margin-bottom: 5px;
  color: #3c9c8f;
}
.dialog-footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  padding: 0px;
  padding-top: 30px;
  padding-bottom: 30px;
}
.btn1 {
  background: #3c9c8f;
  color: white;
  width: 140px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin-right: 30px;
  border-radius: 5px;
}
.btn2 {
  background: white;
  color: #999999;
  width: 140px;
  height: 38px;
  text-align: center;
  line-height: 40px;
  border: 1px solid #999999;
  border-radius: 5px;
}
.add_opt {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
  width: 100%;
}
.add_opt span {
  color: #3c9c8f;
  font-size: 14px;
  padding-right: 10px;
}
.more_add {
  cursor: pointer;
  background: #eeeeee;
  color: #999999;
  text-align: center;
  padding: 10px 20px;
  font-size: 14px;
  margin-top: 10px;
  margin-bottom: 20px;
}
.product_lsit {
  margin-top: 30px;
}
.product_info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #000000;
  font-size: 14px;
  &.header{
    margin-bottom: 10px;
  }
  span{
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.product_info img {
  width: 80px;
  height: 80px;
}
.line {
  height: 1px;
  background: #f1f1f1;
  margin-top: 15px;
  margin-bottom: 15px;
}

.prices {
  display: flex;
  flex-direction: column;
}
.p_left {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.prices_1 {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 10px;
}
.prices_1 span:nth-child(odd) {
  width: auto;
  color: #333333;
  font-size: 14px;
  text-align: right;
}
.prices_1 span:nth-child(even) {
  width: auto;
  color: #3c9c8f;
  font-size: 14px;
  text-align: right;
}
.prices_2 {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 10px;
}
.prices_2 span:nth-child(odd) {
  width: auto;
  color: #333333;
  font-size: 14px;
  text-align: right;
}
.prices_2 span:nth-child(even) {
  width: auto;
  color: #3c9c8f;
  font-size: 24px;
  text-align: right;
}

.order_btns {
  display: flex;
  flex-direction: row;
  margin-right: 20px;
  justify-content: flex-end;
  align-items: flex-end;
}
.order_btns1 {
  cursor: pointer;
  background: #3c9c8f;
  font-size: 14px;
  color: white;
  width: 130px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  border-radius: 2px;
}
.order_btns2 {
  cursor: pointer;
  background: #ffffff;
  font-size: 14px;
  color: #757575;
  margin-right: 30px;
  width: 130px;
  text-align: center;
  height: 28px;
  line-height: 28px;
  border: 1px solid #b0b0b0;
  margin-top: 10px;
   border-radius: 2px;
}
.dialog-footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: #F5F5F5;
  padding: 0px;
  padding-top: 30px;
  padding-bottom: 30px;
}
.btn1{
    background: #3C9C8F;
    color: white;
    width: 140px;
    height: 40px;
    text-align: center; 
    line-height: 40px;
    margin-right: 30px;
    border-radius: 5px;
    cursor: pointer;
}
.btn2{
    background: white;
    color: #999999;
    width: 140px;
    height: 38px;
    text-align: center; 
    line-height: 40px;
    border: 1px solid #999999;
    border-radius: 5px;
    cursor: pointer;
}
.coupon{
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #f1f1f1;
  padding-bottom: 10px;
  .label{
    color: #333333;
    font-size: 14px;
  }
  .coupon_list{
    height: 40px;
    width: 200px;
    display: flex;
    align-items: center;
    flex-direction: row;
  }
  .coupon_select{
    height: 40px;
    /deep/ .el-input{
      height: 40px;
      line-height: 40px;
    }
    /deep/ .el-input__inner{
      height: 40px!important;
      line-height: 40px!important;
      border-color:#3c9c8f!important;
    }
    /deep/ .el-input__suffix{
      height: 40px;
      line-height: 40px;
    }
    /deep/ .el-input__icon{
      line-height: 40px;
    }
  }
}
.active_price{
  color: #e69f3e!important;
}
</style>
